import { useQuery } from '@tanstack/react-query';
import { PERMISSIONS } from '@elementary/common-ui/constants/queryKeys';
import { useAuth } from '@frontegg/react';
import * as api from '../services/api';
import { Permission } from '../types';

const useFlags = () => {
  const { isAuthenticated, user } = useAuth();

  // Only fetch flags when user is authenticated AND has an access token
  // This prevents 401 errors when the component mounts before authentication completes
  const shouldFetch = isAuthenticated && !!user?.accessToken;

  const { data, isLoading, isError } = useQuery([PERMISSIONS], api.fetchFlags, {
    enabled: shouldFetch,
  });

  const hasFlag = (key: Permission) => data?.[key] || false;

  return {
    hasFlag,
    isLoading,
    isError,
  };
};

export default useFlags;
